import { FlexAligner, Switch, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { useUserSettings } from '@/hooks';
import { responsive } from '@/utils';

export const PreviewSettings = () => {
  const { t } = useTranslation();
  const { enablePreviewContent, isPending, setEnablePreviewContent } = useUserSettings();

  const handleToggle = () => {
    setEnablePreviewContent(!enablePreviewContent);
  };

  return (
    <FlexAligner direction='column' gap={responsive.spacing.xsmall}>
      <Typography type='buttontext_medium'>{t('preview')}</Typography>
      <Switch
        label={t('previewDescription')}
        checked={enablePreviewContent}
        onChange={handleToggle}
        disabled={isPending}
      />
    </FlexAligner>
  );
};
